import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { getWayFilter } from "@/pages/coupon/constant/coupon-filter";
import { dateFormatter } from "project-config/utils/date-formatter";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function useFreeColumns() {
  const { t } = useTranslation("center");

  const columns: ColumnsType<any> = [
    { dataIndex: "couponNo", title: t("record_header_coupon_id") },
    {
      dataIndex: "getWay",
      title: t("record_header_claim_method"),
      render: (row) => getTranslateNsT("coupon")(getWayFilter(row)),
    },
    {
      dataIndex: "inOutCome",
      title: t("record_header_type"),
      render: (row: number) =>
        ({ 1: t("income_type"), 2: t("outcome_type") }[row]),
    },
    {
      dataIndex: "useDate",
      title: t("record_header_use_time"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "createDate",
      title: t("record_header_gift_time"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "expireDate",
      title: t("record_header_expire_date"),
      render: (row) => dateFormatter(row),
    },
    {
      dataIndex: "relatedNo",
      title: t("coupon_header_source"),
      render: (row, r) => (row ? `${r.destName}:${row}` : ""),
    },
  ];

  return { columns };
}
